import { stripNonNumericCharacters } from '@thesavingsgroup/utils/stripNonNumericCharacters';

export const toDOBString = (value?: string | number | null): string => {
  const digits = stripNonNumericCharacters(value).slice(0, 8);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};
